async function freeProduct(cart) {
  const { items } = cart;
  const sameCollectionItemsMap = {};
  const handleTotalPriceArray = [];
  let cartDiscount = cart.total_discount / 100;
  var  UnlockedItemId,
  UnlockedItem = [],
  ExfreeItem = [],
  Arrayupdate = [],
  NeedtoRemove = [],
  NeedtoAdd = [],
  Rp = { updates: {} },
  Needtoupdate = false,
  Product1 = parseInt($('#freeProduct').val()),
  Product2 = parseInt($('#secondFreeProduct').val());


  if (items.length > 0) {    
    const paidItemCount = items.reduce((count, item) => 
        (!item.properties || !item.properties['_free-product']) ? count + item.quantity : count, 
    0);
    
    if (paidItemCount == 0) {
      const freeProductKeys = items
      .filter(item => item.properties && item.properties['_free-product'])
      .map(item => item.key);
      
      const updates = {};
  
      freeProductKeys.forEach(key => {
          updates[key] = 0; // Setting quantity to 0 removes the item
      });
  
      fetch('/cart/update.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
      })
      .then(response => response.json())
      .then(data => {
          refreshCart()
          // location.reload(); // Refresh the cart page
      })
      .catch(error => console.error('Error updating cart:', error));
    }
  }
  
  var total_items = new Array();
  items.forEach((item) => {
    total_items.push(item.id);
    window.cartFreeProduct.forEach((collection) => {
      const collectionHandle = collection.collectionHandle;

      if (item.properties["_collections"] === collectionHandle) {
        sameCollectionItemsMap[collectionHandle] =
          sameCollectionItemsMap[collectionHandle] || [];
        sameCollectionItemsMap[collectionHandle].push(item);
      }
    });
  });

  for (const handle in sameCollectionItemsMap) {
    if (Object.prototype.hasOwnProperty.call(sameCollectionItemsMap, handle)) {
      const sameCollectionItems = sameCollectionItemsMap[handle];
      let totalPrice = sameCollectionItems.reduce(
        (sum, item) =>
          sum +
          parseFloat(
            Shopify.currency.active === "INR"
              ? item.price / 100
              : item.discounted_price != ""
              ? item.discounted_price
              : item.price
          ) *
            parseInt(item.quantity),
        0
      );

      handleTotalPriceArray.push({ handle, totalPrice });
    }
  }
  // console.log(handleTotalPriceArray,"handleTotalPriceArrayhandleTotalPriceArrayhandleTotalPriceArray")

  var total_handle = new Array();
  handleTotalPriceArray.forEach((entry) => {
    total_handle.push(entry.handle);
    window.cartFreeProduct.forEach((collection) => {
      if (entry.handle === collection.collectionHandle) {
        // if (entry.totalPrice >= collection.firstProductPrice) {
          // console.log(Product1,'entry.totalPrice');
          if(!Product1 && isNaN(Product1)){
            return
          }

          console.log(collection.secondProductPrice,collection.firstProductPrice,entry.totalPrice,'entry.totalPrice');
          
          if(collection.secondProductPrice != 0 && entry.totalPrice >= collection.secondProductPrice){
            UnlockedItem.push(Product1);
            UnlockedItem.push(Product2);
          }else if(collection.firstProductPrice && entry.totalPrice >= collection.firstProductPrice){
            UnlockedItem.push(Product1);
          }

          for(let i=0; i < items.length;i++){
            var Item = items[i];
            if(Item.id == Product1 || Item.id == Product2 ){
              if (Item.properties['_free-product']) {
                ExfreeItem.push(Item.id);
              }
            }
          }

          for(let j=0; j < ExfreeItem.length; j++){
            // console.log(ExfreeItem,'ExfreeItem');
            var Ex = ExfreeItem[j];
            if(jQuery.inArray(Ex,UnlockedItem) == -1){
              Needtoupdate = true;
              NeedtoRemove.push(Ex);
              Rp.updates[Ex] = 0;
            }
          }

          for(let k=0; k < UnlockedItem.length; k++){
            var Fr = UnlockedItem[k];
            if(jQuery.inArray(Fr,ExfreeItem) == -1){
              Needtoupdate = true;
              NeedtoAdd.push(Fr);
            }
          }

          console.log(NeedtoRemove,'NeedtoRemove');

          if(Needtoupdate){
            if(NeedtoRemove.length){
              jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: Rp,
                dataType: 'json',
                success: function(res) {
                  if(NeedtoAdd.length){
                    freeProductAddToCart(NeedtoAdd);
                  } else{
                    refreshCart();
                  }
                }
              });
            }else if(NeedtoAdd.length){
              freeProductAddToCart(NeedtoAdd);
            }
          }

          fetch('/cart.js').then(res => res.json()).then((cart) => {
            window.cart = cart;
            var ForceUpdate = { updates: {} },
                Items = cart.items,
                ForceUpdatestatus = false;
            for(let m=0; m < Items.length; m++){
              var Item = Items[m];
              if(Item.id == Product1 || Item.id == Product2){
                if(Item.quantity > 1){
                  ForceUpdate.updates[Item.id] = 1;
                  ForceUpdatestatus = true;
                }
              }
              if (Item.properties_all && Item.properties_all['_free-product'] || Item.properties && Item.properties['_free-product']) {
                if(Item.id != Product1 && Item.id != Product2){
                  ForceUpdate.updates[Item.id] = 0;
                  ForceUpdatestatus = true;
                }
              }
            }
            if(ForceUpdatestatus){
              jQuery.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: ForceUpdate,
                dataType: 'json',
                success: function(res) {
                  refreshCart();
                }
              });
            }
          });

        // } 
      }
    });
  });

  UpdateProgressBar(cart, handleTotalPriceArray);
}

          
function freeProductAddToCart(Products) {
  console.log(Products,'Products');
  if(Products.length){
    let formData = { 'items': [] };
    for(let i=0; i < Products.length; i++){
      if(Products[i]){
        formData.items.push({ 'id': Products[i],'quantity': 1, properties:{'_free-product':'true'} })
      }
    }
    if(formData.items.length){
      var selfThis = this;
      fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
         refreshCart();
         freeProductAnimation();
      }).catch((error) => {
        refreshCart();  
      });
    }
  } 
}

function freeProductAnimation() {
  const titleElement = document.querySelector("#cartdrawer-progress-bar");
  const rect = titleElement.getBoundingClientRect();

  confetti({
    particleCount: 150,
    spread: 70,
    startVelocity: 30,
    decay: 0.9,
    colors: ["#DABBD5", "#CEC36A"],
    origin: {
      x: (rect.left + rect.width / 2) / window.innerWidth,
      y: (rect.top + rect.height / 2) / window.innerHeight,
    },
  });
}

function refreshCart() {
  const configElement = document.getElementById("cart-config");
  if (!configElement) return;

  const config = JSON.parse(configElement.innerHTML || "{}");
  Shopify.theme.cart.getCart().then((cart) => {
    Shopify.theme.ajaxCart.updateView(config, cart);
    setTimeout(() => {
      document.body.classList.add("cart-loaded");
    }, 800);
  });
}

async function UpdateProgressBar(cart, handleTotalPriceArray) {
  var Items = cart.items;
  var cartTotalPrice = cart.total_price;

  handleTotalPriceArray.forEach(function (entry) {
    for (let index = 0; index < window.cartFreeProduct.length; index++) {
      var items = window.cartFreeProduct[index];
      if (entry.handle == items.collectionHandle) {
        cartTotalPrice = entry.totalPrice;
      }
    }
  });

  var productFirstPrice = 0,
    secondProductPrice = 0;

  var collectionEnable = true;
  for (let i = 0; i < Items.length; i++) {
    var item = Items[i];
    for (let index = 0; index < window.cartFreeProduct.length; index++) {
      var collection = window.cartFreeProduct[index];
      var collectionHandle = collection.collectionHandle;
      if (collectionHandle == "" || collectionHandle == "all") {
        collectionEnable = false;
      }
      if (item.properties["_collections"] === collectionHandle) {
        productFirstPrice = collection.firstProductPrice || 0;
        secondProductPrice = collection.secondProductPrice || 0;
      }
    }
  }

  // // console.log('collection',collectionEnable);

  // $("#cartdrawer-progress-bar").attr("data-freeShipping", productFirstPrice);
  $("#cartdrawer-progress-bar").attr("data-firstproduct", productFirstPrice);
  $("#cartdrawer-progress-bar").attr("data-secondproduct", secondProductPrice);

  var firstFreeProduct = parseFloat(
      $(".cartdrawer-progress-bar").attr("data-firstproduct")
    ),
    secondFreeProduct = parseFloat(
      $(".cartdrawer-progress-bar").attr("data-secondproduct")
    ),
    freeShipping = parseFloat(
      $(".cartdrawer-progress-bar").attr("data-freeShipping")
    );

  if (cartTotalPrice > 0) {
    if (!isNaN(firstFreeProduct) || !isNaN(secondFreeProduct)) {
      if (
        firstFreeProduct != 0 ||
        secondFreeProduct != 0 ||
        freeShipping != 0
      ) {
        $("#cartdrawer-progress-bar").addClass("enableProgressBar");
      } else {
        // console.log('1');
        $("#cartdrawer-progress-bar").removeClass("enableProgressBar");
      }
    } else {
      // console.log('2');
      $("#cartdrawer-progress-bar").removeClass("enableProgressBar");
    }
  } else {
    // console.log('3');
    $("#cartdrawer-progress-bar").removeClass("enableProgressBar");
  }

  if (firstFreeProduct > 0) {
    $(".threshold-bar-progress").addClass("space-bottom");
  } else {
    $(".threshold-bar-progress").removeClass("space-bottom");
  }

  if (firstFreeProduct != 0 || secondFreeProduct != 0) {
    var highestThreshold = Math.max(
      freeShipping,
      firstFreeProduct,
      secondFreeProduct
    );
    var combinedPercentage = (cartTotalPrice * 95) / highestThreshold;

    var freeShippingPr = (freeShipping * 95) / highestThreshold;
    var firstProductPr = (firstFreeProduct * 95) / highestThreshold;
    var secondProductPr = (secondFreeProduct * 95) / highestThreshold;
  }

  if (firstFreeProduct == 0 && secondFreeProduct == 0) {
    var freeShippingPr = 95;
    var combinedPercentage = (cartTotalPrice * 95) / freeShipping;
  }

  if (combinedPercentage > 100) {
    var combinedPercentage = 100;
  }

  $("#cartdrawer-progress-bar")
    .find(".threshold-bar-progress-inner")
    .css("width", combinedPercentage + "%");
  $("#cartdrawer-progress-bar")
    .find(".threshold-bar-indicator.zero")
    .css("left", freeShippingPr + "%");
  $("#cartdrawer-progress-bar")
    .find(".threshold-bar-indicator.first")
    .css("left", firstProductPr + "%");
  $("#cartdrawer-progress-bar")
    .find(".threshold-bar-indicator.second")
    .css("left", secondProductPr + "%");

  if (cartTotalPrice >= freeShipping) {
    $("#cartdrawer-progress-bar")
      .find(".threshold-bar-indicator.zero")
      .addClass("active");
  } else {
    $("#cartdrawer-progress-bar")
      .find(".threshold-bar-indicator.zero")
      .removeClass("active");
  }

  if (cartTotalPrice >= firstFreeProduct) {
    $("#cartdrawer-progress-bar")
      .find(".threshold-bar-indicator.first")
      .addClass("active");
  } else {
    $("#cartdrawer-progress-bar")
      .find(".threshold-bar-indicator.first")
      .removeClass("active");
  }

  if (cartTotalPrice >= secondFreeProduct) {
    $("#cartdrawer-progress-bar")
      .find(".threshold-bar-indicator.second")
      .addClass("active");
  } else {
    $("#cartdrawer-progress-bar")
      .find(".threshold-bar-indicator.second")
      .removeClass("active");
  }

  if (firstFreeProduct == 0) {
    $("#cartdrawer-progress-bar")
      .find(".threshold-bar-indicator.first")
      .addClass("hidden");
  } else {
    $("#cartdrawer-progress-bar")
      .find(".threshold-bar-indicator.first")
      .removeClass("hidden");
  }

  if (secondFreeProduct == 0) {
    $("#cartdrawer-progress-bar")
      .find(".threshold-bar-indicator.second")
      .addClass("hidden");
  } else {
    $("#cartdrawer-progress-bar")
      .find(".threshold-bar-indicator.second")
      .removeClass("hidden");
  }

  var firstSuccessMessage = $("#cartdrawer-progress-bar").attr(
    "data-success-message"
  );
  var secondSuccessMessage = $("#cartdrawer-progress-bar").attr(
    "data-success-message-second"
  );
  var thirdSuccessMessage = $("#cartdrawer-progress-bar").attr(
    "data-success-message-third"
  );
  var progressMessage = $("#cartdrawer-progress-bar").attr(
    "data-progress-message"
  );
  var messageParts = progressMessage.split("{{amount}}");
  var firstHalfMessage = messageParts[0];
  var secondHalfMessage = messageParts[1].replace("{{target}}", ""),
    firstBreakPoint = $("#cartdrawer-progress-bar").attr(
      "data-shipping-breakpoint"
    ),
    secondGiftBreakPoint = $("#cartdrawer-progress-bar").attr(
      "data-firstgift-breakpoint"
    ),
    thirdGiftBreakPoint = $("#cartdrawer-progress-bar").attr(
      "data-second-breakpoint"
    );

  var successMessage;
  var nextTarget;
  var targetOffer;

  // if (cartTotalPrice < freeShipping) {
  //     nextTarget = freeShipping;
  //     targetOffer = "Free Shipping";
  // } else if (cartTotalPrice < firstFreeProduct) {
  //     nextTarget = firstFreeProduct;
  //     targetOffer = false;
  // } else if (cartTotalPrice < secondFreeProduct) {
  //     nextTarget = secondFreeProduct;
  //     targetOffer = false;
  // } else {
  //     targetOffer = false;
  // }

  // if (cartTotalPrice >= secondFreeProduct) {
  //     successMessage = thirdSuccessMessage;
  // } else if (cartTotalPrice >= firstFreeProduct) {
  //     successMessage = secondSuccessMessage;
  // } else if (cartTotalPrice >= freeShipping) {
  //     successMessage = firstSuccessMessage;
  // } else {
  //     successMessage = '';
  // }

  const highestsThreshold = Math.max(
    freeShipping,
    firstFreeProduct,
    secondFreeProduct
  );
  const lowestThreshold = Math.min(
    freeShipping,
    firstFreeProduct,
    secondFreeProduct
  );
  const thresholdsArray = [freeShipping, firstFreeProduct, secondFreeProduct];

  let second_Threshold = 0;
  for (let i = 0; i < thresholdsArray.length; i++) {
    const thresholdNumber = thresholdsArray[i];
    if (
      thresholdNumber < highestThreshold &&
      thresholdNumber > lowestThreshold
    ) {
      second_Threshold = thresholdNumber;
    }
  }

  if (firstFreeProduct != 0 && secondFreeProduct != 0) {
    if (freeShipping != 0) {
      if (cartTotalPrice < lowestThreshold) {
        nextTarget = lowestThreshold;
        targetOffer = firstBreakPoint;
      } else if (cartTotalPrice < second_Threshold) {
        nextTarget = second_Threshold;
        targetOffer = secondGiftBreakPoint;
        // successMessage = firstSuccessMessage;
      } else if (cartTotalPrice < highestsThreshold) {
        nextTarget = highestsThreshold;
        targetOffer = thirdGiftBreakPoint;
        // successMessage = thirdGiftBreakPoint;
      } else {
        targetOffer = "";
        if (cartTotalPrice >= secondFreeProduct) {
          successMessage = firstSuccessMessage;
        }
      }
    } else {
      if (cartTotalPrice < lowestThreshold) {
        nextTarget = lowestThreshold;
      } else if (cartTotalPrice < second_Threshold) {
        nextTarget = second_Threshold;
        targetOffer = firstBreakPoint;
      } else if (cartTotalPrice < highestsThreshold) {
        nextTarget = highestsThreshold;
        targetOffer = secondGiftBreakPoint;
        // successMessage = thirdGiftBreakPoint;
      } else {
        targetOffer = "";
        if (cartTotalPrice >= secondFreeProduct) {
          successMessage = firstSuccessMessage;
        }
      }
    }
  } else if (firstFreeProduct != 0 || secondFreeProduct != 0) {
    if (freeShipping != 0) {
      if (cartTotalPrice < lowestThreshold) {
        nextTarget = lowestThreshold;
      } else if (cartTotalPrice < second_Threshold) {
        nextTarget = second_Threshold;
        targetOffer = firstBreakPoint;
      } else if (cartTotalPrice < highestsThreshold) {
        nextTarget = highestsThreshold;
        targetOffer = secondGiftBreakPoint;
        successMessage = firstSuccessMessage;
      }
      if (cartTotalPrice >= highestsThreshold) {
        successMessage = firstSuccessMessage;
      }
    } else {
      if (cartTotalPrice < highestsThreshold) {
        nextTarget = highestsThreshold;
        targetOffer = firstBreakPoint;
      }
      if (cartTotalPrice >= freeShipping) {
        successMessage = firstSuccessMessage;
      }
    }
  } else {
    if (cartTotalPrice < highestsThreshold) {
      nextTarget = highestsThreshold;
      if (collectionEnable) {
        targetOffer = secondGiftBreakPoint;
      } else {
        targetOffer = firstBreakPoint;
      }
    }
    if (cartTotalPrice >= freeShipping) {
      if (collectionEnable) {
        successMessage = firstSuccessMessage;
      } else {
        successMessage = firstSuccessMessage;
      }
    }
  }

  if ($("#cartdrawer-progress-bar").data("shipping-steps") == 1) {
    successMessage = firstSuccessMessage;
  } else if ($("#cartdrawer-progress-bar").data("shipping-steps") == 2) {
    successMessage = secondSuccessMessage;
  } else if ($("#cartdrawer-progress-bar").data("shipping-steps") == 3) {
    successMessage = thirdSuccessMessage;
  } else {
    successMessage = firstSuccessMessage;
  }

  if (targetOffer) {
    if (Shopify.currency.active == "INR") {
      var inrAmount = nextTarget - cartTotalPrice;
      var remainingAmount = inrAmount * 100;
    } else {
      var remainingAmount = nextTarget - cartTotalPrice;
    }
    let config = document.getElementById("cart-config");
    $(".progress-bar-messages").html(
      '<div class="progress-messages messages">' +
        firstHalfMessage +
        '<span class="remaining-amount">' +
        theme.Helpers.formatMoney(remainingAmount, config.money_format) +
        "</span>" +
        secondHalfMessage +
        '<span class="next-progress-name">' +
        targetOffer +
        "</span>.</div>"
    );
  } else {
    $(".progress-bar-messages").html(
      '<div class="complete-messages messages">' + successMessage + "</div>"
    );
  }
}

